import { render, staticRenderFns } from "./ProductDetailScreen.vue?vue&type=template&id=192574ec&scoped=true"
import script from "./ProductDetailScreen.vue?vue&type=script&lang=js"
export * from "./ProductDetailScreen.vue?vue&type=script&lang=js"
import style0 from "./ProductDetailScreen.vue?vue&type=style&index=0&id=192574ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192574ec",
  null
  
)

export default component.exports